// 外部关系api
import request from '@/util/request'

// 获取外部商家
export function GetRelBusList (params) {
  params.language = stage.languageId
  return request({
    url: `/user-s/acc/entity-rels/target-org`,
    method: 'get',
    params
  })
}
// 删除外部商家
export function DelRelBus (id) {
  return request({
    url: `/user-s/acc/entity-rel/target-org/${id}`,
    method: 'delete'
  })
}
// 批量删除外部商家
export function DelRelBatchBus (data) {
  return request({
    url: `/user-s/acc/entity-rel/target-org/batch`,
    method: 'delete',
    data
  })
}
// 编辑商家关系
export function EditEntityRelBus (id, params) {
  return request({
    url: `/user-s/acc/entity-rel/target-org/${id}`,
    method: 'post',
    params
  })
}
// 创建新商家的关系
// export function AddUserRole (data) {
//   return request({
//     url: `/user-s/acc/entity-rel`,
//     method: 'post',
//     data
//   })
// }
export function AddBusRole (data) {
  return request({
    url: `/user-s/acc/entity-rel/target-org`,
    method: 'post',
    data
  })
}
// 获取外部用户
export function GetRelUserList (params) {
  return request({
    url: `/user-s/acc/entity-rels/target-personal`,
    method: 'get',
    params
  })
}
// 删除外部用户
export function DelRelUser (id) {
  return request({
    url: `/user-s/acc/entity-rel/target-personal/${id}`,
    method: 'delete'
  })
}
// 批量删除外部用户
export function DelRelBatchUser (data) {
  return request({
    url: `/user-s/acc/entity-rel/target-personal/batch`,
    method: 'delete',
    data
  })
}
// 编辑用户关系
export function EditEntityRelUser (id, params) {
  return request({
    url: `/user-s/acc/entity-rel/target-personal/${id}`,
    method: 'post',
    params
  })
}
export function AddUserRole (data) {
  return request({
    url: `/user-s/acc/entity-rel/target-personal`,
    method: 'post',
    data
  })
}
export function GetRel (id) {
  return request({
    url: `/user-s/acc/entity-rel/${id}`,
    method: 'get'
  })
}
export function DelRel (id) {
  return request({
    url: `/user-s/acc/entity-rel/${id}`,
    method: 'delete'
  })
}
// 搜索全系商家
export function AllOrgs (params) {
  params.language = stage.languageId
  return request({
    url: `/user-s/acc/orgs`,
    method: 'get',
    params
  })
}
// 搜索全系用户
export function AllUsers (params) {
  return request({
    url: `/user-s/acc/users`,
    method: 'get',
    params
  })
}
// 编辑商家或者用户之间的关系
export function EditEntityRel (id, params) {
  return request({
    url: `/user-s/acc/entity-rel/${id}`,
    method: 'post',
    params
  })
}

// 创建新用户
export function AddNewUser (data) {
	data.userInfo.system=stage.loc.customer
  return request({
    url: `/user-s/acc/user`,
    method: 'post',
    data
  })
}
// 创建新的商家
export function addNewBus (data) {
	data.org.system=stage.loc.customer
  return request({
    url: `/user-s/acc/org`,
    method: 'post',
    data
  })
}
// 更新新的商家
export function updateNewBus (data) {
  return request({
    url: `/user-s/acc/org/my`,
    method: 'post',
    data
  })
}

// 更新新的商家
export function addorg (data) {
  return request({
    url: `/user-s/acc/entity-rel/org `,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/manage/externalRelative.js